export type CouponType = 'correction' | 'newdate' | 'giftcard' | 'reimburse';

export type CouponFormData = {
  type: CouponType;
  customerId: string;
  reason: string;
};

export type SelectOption = {
  id: string;
  value: string;
  label: string;
};

export const COUPON_TYPE_OPTIONS: SelectOption[] = [
  { id: 'giftcard', value: 'Coupons::Goodwills::GiftCard', label: 'Geschenkkarte' },
  { id: 'correction', value: 'Coupons::Goodwills::Correction', label: 'Korrektur' },
  { id: 'newdate', value: 'Coupons::Goodwills::NewDate', label: 'Neues Datum' },
  { id: 'reimburse', value: 'Coupons::Goodwills::Reimbursement', label: 'Erstattung' },
];
